import { message } from 'antd';
console.log(message);

message.config({
  top: '40%'
});

export default class AntdMessage {
  static warning = message.warning;
  static info = message.info;
  static error = message.error;
  static success = message.success;
  static loading = message.loading;
  static destroy = message.destroy;
}
